import { FactoryAds, FactoryAdsContainers } from './advertising/AdFactory'
import { AdParam } from './advertising/contanst'

try {
  if (!AdParam.section) {
    throw Error('no se encontro el data-attribute Section')
  }
  /* if (!AdParam.client) {
    throw Error('no se encontro el data-attribute client')
  } */
  const containers = document.querySelectorAll("[data-type='adContainer']")
  const quantityContainerForType = {}
  containers.forEach((container) => {
    if (!quantityContainerForType[container.getAttribute('data-adContainer')]) {
      quantityContainerForType[container.getAttribute('data-adContainer')] = []
    }
    quantityContainerForType[container.getAttribute('data-adContainer')].push(container.getAttribute('data-element'))
  })

  // Reemplaza 'mi_parametro' con el nombre del parámetro que deseas obtener
  if (AdParam.singleAd) {
    for (const i in quantityContainerForType) {
      const adFactory = new FactoryAds(quantityContainerForType[i].length == 1 ? quantityContainerForType[i][0] : quantityContainerForType[i], i, quantityContainerForType[i].length)
      adFactory.get()
    }
  } else {
    const adFactory = new FactoryAdsContainers(quantityContainerForType)
    adFactory.get()
  }
} catch (ex) {
  console.error(ex)
}
